import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
import config from 'config/default.json';
import { DialogComponent } from 'src/app/back-office/components/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UploadContentComponent } from 'src/app/back-office/components/upload-content/upload-content.component';

@Component({
  selector: 'app-vcl-upload-content',
  templateUrl: './vcl-upload-content.component.html',
  styleUrls: ['./vcl-upload-content.component.scss']
})
export class VcUploadContentComponent {
  constructor(
    private elRef:ElementRef,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private apiService: ApiServiceModule,
    private helper: HelperModule,
    public dialog: MatDialog,
    private sharedService: SharedService
    ) {}
  @Input() userInfos: { [x:string]: any } = new Map();
  @ViewChild('appUploadContent', { static: true }) appUploadContent!: UploadContentComponent;
  acceptedExtention: string[] = ['svg', 'png', 'pdf', 'jpg', 'jpeg', 'docx', 'doc', 'dot', 'docm', 'dotm', 'dotx', 'webp', 'heic'];

  pageId = 'vcl-upload-content'
  modes:{ [x:string]: string|number }[] = [];//[{id:1, key: 'raw', value: 'Raw'}, {id: 2, key: 'video', value: 'Video'}];
  platformInfos:{[x: string]: any} = {origin: 'virtualclass', key: 'vcl', root: 'VIRTUALCLASS'}
  filterData: {[x: string]: any} = {}

  ngOnInit(){

  }
  filterUploadContent(filterData: any){
    this.filterData = filterData;
    this.helper.showToast('Filter updated...'); 
  }
  uploadEvent(uploadResult: any){
    
  }
  setProgress(data:any){

  }
}
